import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-1978adbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fr-panel" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "fr-done-ico" }, "✓", -1));
const _hoisted_3 = { class: "fr-panel__title fr-panel__title--plain" };
const _hoisted_4 = { class: "fr-center fr-hint fr-done-notify" };
const _hoisted_5 = { class: "fr-badge-free" };
const _hoisted_6 = {
    key: 0,
    class: "fr-done-manage"
};
const _hoisted_7 = { class: "fr-center fr-hint" };
const _hoisted_8 = ["href"];
import { t } from '@vue/services/interval-lang';
import { bookingState } from '@vue/services/interval-store';
import BookingSummary from '@vue/components/interval/BookingSummary.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingDone',
    setup(__props) {
        /**
         * 訂位完成（原型步驟 5）。
         *
         * 「查詢／退訂」按鈕掛的是 reserving 回傳的訂單短網址，
         * 與寄給客人的簡訊／Email 是同一組；沒拿到短網址就整塊不顯示，
         * 寧可少一個按鈕，也不要給出點了會 404 的連結。
         */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('bk.doneTitle')), 1),
                _createVNode(BookingSummary),
                _createElementVNode("p", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_unref(t)('bk.doneNotify')) + " ", 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('bk.free')), 1)
                ]),
                (_unref(bookingState).orderShortUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('bk.doneManageHint')), 1),
                        _createElementVNode("a", {
                            class: "fr-btn",
                            href: _unref(bookingState).orderShortUrl,
                            target: "_blank",
                            rel: "noopener"
                        }, _toDisplayString(_unref(t)('bk.doneManage')), 9, _hoisted_8)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
